import React from 'react';
import PropTypes from 'prop-types';
import css from './Sections.module.css';
import { Icons } from '../../../components';

function SectionFeatures({ intl }) {
  const featureItems = [
    {
      icon: 'buyerProtection',
      title: intl.formatMessage({ id: 'TrustAndSafetyPage.SectionFeatures.buyerProtection.title' }),
      description: intl.formatMessage({ id: 'TrustAndSafetyPage.SectionFeatures.buyerProtection.description' }),
    },
    {
      icon: 'escrowPayment',
      title: intl.formatMessage({ id: 'TrustAndSafetyPage.SectionFeatures.escrowPayments.title' }),
      description: intl.formatMessage({ id: 'TrustAndSafetyPage.SectionFeatures.escrowPayments.description' }),
    },
    {
      icon: 'dailyMenualCheck',
      title: intl.formatMessage({ id: 'TrustAndSafetyPage.SectionFeatures.dailyManualChecks.title' }),
      description: intl.formatMessage({ id: 'TrustAndSafetyPage.SectionFeatures.dailyManualChecks.description' }),
    },
    {
      icon: 'disputeCentre',
      title: intl.formatMessage({ id: 'TrustAndSafetyPage.SectionFeatures.disputeCentre.title' }),
      description: intl.formatMessage({ id: 'TrustAndSafetyPage.SectionFeatures.disputeCentre.description' }),
    },
  ];
  return (
    <div className={css.featuresContainer}>
      <div className={css.fixedWidthContainer}>
        <div className={css.featuresContent}>
          {featureItems.map(({ title, description, icon }, index) => (
            <div key={index} className={css.categoryItem}>
              <Icons name={icon} />
              <h3>{title}</h3>
              <p>{description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}


export default SectionFeatures;